import BackToTop from '@unctad-infovis/general-tools/components/BackToTop.jsx';
import ProgressBar from '@unctad-infovis/general-tools/components/ProgressBar.jsx';
import { useRef } from 'react';

import ChapterBanner from './components/beyond_gdp/ChapterBanner.jsx';
import ChartData from './components/beyond_gdp/ChartData.jsx';
import ChartPair from './components/beyond_gdp/ChartPair.jsx';
import ChartSection from './components/beyond_gdp/ChartSection.jsx';
import DashboardFramework from './components/beyond_gdp/DashboardFramework.jsx';
import DualBarRowsLoader from './components/beyond_gdp/DualBarRowsLoader.jsx';
import GapChart from './components/beyond_gdp/GapChart.jsx';
import Header from './components/beyond_gdp/Header.jsx';
import Nav from './components/beyond_gdp/Nav.jsx';
import RevealList from './components/beyond_gdp/RevealList.jsx';
import RevealOnView from './components/beyond_gdp/RevealOnView.jsx';
import SectionDivider from './components/beyond_gdp/SectionDivider.jsx';
import StatTiles from './components/beyond_gdp/StatTiles.jsx';
import Timeline from './components/beyond_gdp/Timeline.jsx';
import TranslationDisclaimer from './components/beyond_gdp/TranslationDisclaimer.jsx';
import BarPair from './components/charts/BarPair.jsx';
import DualBarRows from './components/charts/DualBarRows.jsx';
import GroupedBarChart from './components/charts/GroupedBarChart.jsx';
import LineChartMulti from './components/charts/LineChartMulti.jsx';
import ScatterLog from './components/charts/ScatterLog.jsx';

import './components/beyond_gdp/beyond_gdp.css';
import '@unctad-infovis/general-tools/styles/styles.css';

const components = {
  BackToTop,
  BarPair,
  ChapterBanner,
  ChartData,
  ChartPair,
  ChartSection,
  DashboardFramework,
  DualBarRows,
  DualBarRowsLoader,
  GapChart,
  GroupedBarChart,
  Header,
  LineChartMulti,
  Nav,
  ProgressBar,
  RevealList,
  RevealOnView,
  ScatterLog,
  SectionDivider,
  StatTiles,
  Timeline,
  TranslationDisclaimer
};

const App = ({ Article, meta }) => {
  const appRef = useRef();

  window.appRef = appRef;

  return (
    <div className="app" ref={appRef} style={{ '--main-color': 'var(--un-color-yellow)' }}>
      <Article components={components} meta={meta} />
    </div>
  );
};

export default App;
